import { Payment } from "./Payment";
import { BankTransferPayment } from "./BankTransferPayment";
import { PayPalPayment } from "./PayPalPayment";
export class PaymentFactory {
  static create($type) {
    if ($type === "V1.Payments.Pay.Payment") {
      const result = new Payment();
      return result;
    }
    if ($type === "V1.Payments.Pay.BankTransferPayment") {
      const result = new BankTransferPayment();
      return result;
    }
    if ($type === "V1.Payments.Pay.PayPalPayment") {
      const result = new PayPalPayment();
      return result;
    }
    throw new Error($type + " not found");
  }
}
